import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import Container from "../../../../constants/Container";

interface ChartState {
    series: { data: number[] }[];
    options: ApexOptions;
}

const HorizontalChart: React.FC = () => {
    const [state, setState] = useState<ChartState>({
        series: [
            {
                data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380],
            },
        ],
        options: {
            chart: {
                type: "bar",
                height: 350,
                toolbar: {
                    show: false, // 👈 hides the menu entirely
                },
            },
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    borderRadiusApplication: "end" as const,
                    horizontal: true,
                },
            },
            dataLabels: {
                enabled: false,
            },
            xaxis: {
                categories: [
                    "Sushil KC",
                    "Ramesh Basnet",
                    "Sunil Regmi",
                    "Dinesh Chaudhary",
                    "Suman Regmi",
                    "Dipak Adhikari",
                    "Sirjana Shrestha",
                    "Susmita Gurung",
                    "Ramita Bista",
                    "Hima Basnet",
                ],
            },
        },
    });

    return (
        <Container padding>
            <div id="chart">
                <ReactApexChart
                    options={state.options}
                    series={state.series}
                    type="bar"
                    height={350}
                />
            </div>
            <div id="html-dist"></div>
        </Container>
    );
};

export default HorizontalChart;
